import * as React from 'react';
import * as ReactDOM from 'react-dom';
import styles from './QRCodeDialog.module.scss';

import { Dialog, DialogType, DefaultButton, DialogFooter } from '@fluentui/react';
import { QRCode } from 'react-qrcode-logo';

export interface QRCodeDialogProps {
  title: string;
  url: string;
}

export class QRCodeDialog {
  public static show(options: QRCodeDialogProps) {
    const dialogNode = document.createElement('div');
    const close = (): void => {
      ReactDOM.unmountComponentAtNode(dialogNode);
      dialogNode.remove();
    };
    ReactDOM.render(<QRCodeDialogInternal {...options} close={close} />, dialogNode);
  }
}

function download(component: QRCode | null, filename: string) {
  // eslint-disable-next-line
  const canvas: any = (ReactDOM as any).findDOMNode(component);

  const lnk: any = document.createElement('a');

  lnk.download = filename.replace(/\s/g, '_');

  lnk.href = canvas.toDataURL('image/png;base64');

  if (document.createEvent) {
    const e = document.createEvent('MouseEvents');
    e.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
    lnk.dispatchEvent(e);
  } else if (lnk.fireEvent) {
    lnk.fireEvent('onclick');
  }
}

class QRCodeDialogInternal extends React.Component<QRCodeDialogProps & { close: () => void }> {
  private qrcode = React.createRef<QRCode>();
  public render(): JSX.Element {
    return (
      <Dialog
        hidden={false}
        modalProps={{
          className: styles.qrCodeDialog,
        }}
        dialogContentProps={{
          type: DialogType.normal,
          title: this.props.title,
        }}
        onDismiss={this.cancel}
      >
        <div className="flex justify-center">
          <QRCode ref={this.qrcode} ecLevel="Q" size={400} quietZone={40} bgColor="#FFFFFF" fgColor="#F5416D" qrStyle="dots" value={this.props.url} />
        </div>
        <DialogFooter>
          <DefaultButton text="Download" onClick={() => download(this.qrcode.current, this.props.title)} />
        </DialogFooter>
      </Dialog>
    );
  }

  private cancel = () => {
    this.props.close();
  };
}
